import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-student-notification',
  templateUrl: './student-notification.component.html',
  styleUrls: ['./student-notification.component.scss']
})
export class StudentNotificationComponent implements OnInit {
  NotificationsData: any[];

   constructor(
      private modalPopupService: ModalpopService,
      public umsService: UmsService,
      private spinner: NgxSpinnerService,
      public router: Router,
      private dialog:MatDialog,private datePipe: DatePipe,
    ) { }

  ngOnInit(): void {
    this.prepopulation();
  }

  prepopulation() {
    this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = sessionStorage.getItem('StudentRGID');
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          this.SubjectSelectionData(res.data[0].StuId);
        }
      }
      else{
        this.spinner.hide();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  SubjectSelectionData(StuId){
    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId,
    this.umsService.StudentSubjectSelectionById(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        const latestObject = res.data[res.data.length - 1];
        if(parseInt(latestObject['SubSession']) == parseInt(sessionStorage.getItem('session'))){
          this.getApplyData(parseInt(sessionStorage.getItem('session')));
        }
        else if(parseInt(latestObject['SubSession']) < parseInt(sessionStorage.getItem('session'))){
          this.getApplyData(parseInt(latestObject['SubSession']));
        }
      }
      else{
        this.spinner.hide();
      }
    })
  }

  getApplyData(SnNo){
    this.getList(SnNo)
    this.spinner.show();
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
       
      }
      else{
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getList(SnNo) {
    this.spinner.show();
    const payload = {
      CoCode: '',
      SnNo: SnNo,
      CgCode:'',
ApplicationType:'Student',
    };
  
    this.umsService.getStuNotify(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.NotificationsData = res.data
        } else {
          this.NotificationsData = [];
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.NotificationsData = [];
      }
    );
  }

  showbase64(e) { 

    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.DocUpload
      });
  }

  shouldMergeRows(index: number, field: string): boolean {
    if (index === 0) {
      return true;  // Always show the first row
    }
    return this.NotificationsData[index][field] !== this.NotificationsData[index - 1][field];
  }

  // Function to get the rowspan for title or description
  getRowSpan(index: number, field: string): number {
    if (index === 0) {
      return 1;  // Always show the first row
    }

    let span = 1;
    let currentValue = this.NotificationsData[index][field];

    // Calculate rowspan by checking the next rows for the same value
    for (let i = index + 1; i < this.NotificationsData.length; i++) {
      if (this.NotificationsData[i][field] === currentValue) {
        span++;
      } else {
        break;
      }
    }
    return span;
  }


  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy', 'Asia/Kolkata') || '';
  }
}
